<template>
  <form :ref="formRef" class="UIForm">
    <slot />
  </form>
</template>

<script lang="ts" setup>
defineProps({
  label: { type: String, default: '' },
  formRef: { type: String },
})
</script>
